import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import { mapGetters } from 'vuex';
import marketTrendsTab from '@/market-trends/components/markettrendstab/markettrends-tab.vue';
import marketTrendsTabs from '@/market-trends/components/markettrendstabs/markettrends-tabs.vue';
export default {
    name: 'geoLandingMarketTrends',
    components: {
        marketTrendsTabs,
        marketTrendsTab,
        mvtShifter,
    },
    props: ['geoInfo'],
    data() {
        return {
            selectedMarketTrend: 'all',
            selectedMetricId: null,
        };
    },
    computed: {
        ...mapGetters('geolanding', ['geolanding']),
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp']),
        getMetric() {
            return this.data.metric;
        },
        getGeoTitle() {
            if (this.geoInfo) {
                if (this.geoInfo.hasGeoInfo) {
                    if (this.msp.searchType === 'NEIGHBORHOOD') {
                        return this.geoInfo.neighborhood;
                    }
                }
                return this.msp.searchInput || this.geoInfo.formatAddress;
            }
            return this.geolanding?.geo?.formatAddress || '';
        },
        getGeo() {
            return this.msp.geo && this.msp.geo.hasGeoInfo ? this.msp.geo : this.geolanding?.geo;
        },
        getTrendsData() {
            if (this.msp.marketTrendsSummary && this.msp.marketTrendsSummary.length) {
                return this.msp.marketTrendsSummary;
            }
            return this.geolanding?.marketTrendsSummary || [];
        },
        marketTrendsSummary() {
            return this.getTrendsData.find((snap) => snap.type === this.selectedMarketTrend);
        },
        selectedMetric() {
            return this.marketTrendsSummary?.marketSnapShot?.find((market) => market.id === this.selectedMetricId);
        },
    },
    methods: {
        updateMetric(value) {
            this.selectedMetricId = value.id;
        },
        updateMarketTrend(value) {
            this.selectedMarketTrend = value.id;
        },
    },
};
